import { useLanguage } from "@digipost/translate";
import { library } from "@fortawesome/fontawesome-svg-core";
import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router";

import { useSiteImprove } from "./analytics/useSiteImprove";
import styles from "./App.module.less";
import { EntrypointContextProvider } from "./EntrypointContext";
import Header from "./header/Header";
import fontAwesomeIcons from "./infrastructure/fontawesome-icons";
import MobilMenu from "./mobilemenu/MobileMenu";
import StatusPageBanner from "./statuspage/StatusPageBanner";

library.add(...(fontAwesomeIcons as IconDefinition[]));

function App(): React.ReactElement {
  const [openMenu, setOpenMenu] = useState(false);

  useSiteImprove(true);

  const { language } = useLanguage();
  useEffect(() => {
    document.querySelector("html")?.setAttribute("lang", language);
  }, [language]);

  return (
    <div className="App">
      <StatusPageBanner />
      <EntrypointContextProvider>
        {!location.pathname.includes("mobileLogin/") && (
          <div className={styles.headerContainer}>
            <Header
              isActive={openMenu}
              onShow={() => setOpenMenu((prevState) => !prevState)}
            />
          </div>
        )}
        {openMenu && <MobilMenu />}
        <Outlet />
      </EntrypointContextProvider>
    </div>
  );
}

export default App;
